(() => {
  const initSLServices = () => {
    const sections = document.querySelectorAll(".sl-services");

    sections.forEach((section) => {
      if (section.dataset.slServicesInitialized === "true") return;

      section.dataset.slServicesInitialized = "true";

      const heading = section.querySelector(".sl-services__heading");
      const cards = section.querySelectorAll(".sl-service-card");

      cards.forEach((card, index) => {
        card.style.setProperty(
          "--sl-service-delay",
          `${Math.min(index * 90, 450)}ms`
        );
      });

      if (!("IntersectionObserver" in window)) {
        heading?.classList.add("is-visible");
        cards.forEach((card) => card.classList.add("is-visible"));
        return;
      }

      const observer = new IntersectionObserver(
        (entries, currentObserver) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;

            entry.target.classList.add("is-visible");
            currentObserver.unobserve(entry.target);
          });
        },
        {
          threshold: 0.14,
          rootMargin: "0px 0px -50px 0px"
        }
      );

      if (heading) observer.observe(heading);

      cards.forEach((card) => {
        observer.observe(card);
      });
    });
  };

  document.documentElement.classList.add("js");

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initSLServices);
  } else {
    initSLServices();
  }

  document.addEventListener("shopify:section:load", initSLServices);
})();